var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2866 0.479858H4.66049C4.26649 0.479858 3.94713 0.82225 3.94713 1.24475V8.46004H2.68692C1.2053 8.46004 0 9.75266 0 11.3411V15.5988C0 17.1875 1.2053 18.4799 2.68692 18.4799C2.80818 18.4799 2.92757 18.4712 3.04432 18.4544H14.8138C16.5705 18.4544 18 16.9218 18 15.038V1.24475C18 0.82225 17.6807 0.479858 17.2866 0.479858ZM3.94717 15.5988C3.94717 16.2543 3.5094 16.8025 2.93091 16.9246H2.68696V16.9501C1.99192 16.9501 1.42671 16.3438 1.42671 15.5988V11.3411C1.42671 10.5961 1.99216 9.98977 2.68696 9.98977H3.9472V15.5988H3.94717ZM16.5733 15.0379C16.5733 16.0606 15.7677 16.9246 14.8138 16.9246H5.0721C5.26493 16.5276 5.37384 16.0766 5.37384 15.5988V2.00959H16.5733V15.0379ZM7.87053 5.2731H12.3408C12.7348 5.2731 13.0541 5.61549 13.0542 6.03799C13.0542 6.46048 12.7351 6.80287 12.3408 6.80287H7.87053C7.4765 6.80287 7.15717 6.46044 7.15717 6.03799C7.15717 5.61549 7.47653 5.2731 7.87053 5.2731ZM7.87053 8.96995H14.0528C14.4468 8.96995 14.7662 9.31235 14.7662 9.73484C14.7662 10.1573 14.4468 10.4997 14.0528 10.4997H7.87053C7.4765 10.4997 7.15717 10.1573 7.15717 9.73484C7.15717 9.31235 7.47653 8.96995 7.87053 8.96995ZM7.87053 12.4376H12.3408C12.7348 12.4376 13.0541 12.78 13.0542 13.2025C13.0542 13.625 12.7351 13.9674 12.3408 13.9674H7.87053C7.4765 13.9674 7.15717 13.625 7.15717 13.2025C7.15717 12.78 7.47653 12.4376 7.87053 12.4376Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.3a4db1ad.svg";
export { ForwardRef as ReactComponent };